<template>
  <div>
    <!--    <template v-for="(r,i) in records">-->
    <div class="flex flex_gap_10 border-bottom mb-1 pb-1" v-for="(c,i) in detail.array_value">
      <div class="flex-grow-1">
        <textarea @change="updateRecord(c)" placeholder="Новый комментарий" class="form-control" v-model="c.comment"
                  rows="2"/>
      </div>
      <div class="max_width_30">
        <label for="">Проекты (пусто = все проекты)</label>
        <multiselect
          v-model="c.selected_projects"
          :options="getActiveProjects()"
          placeholder="Выберите проект"
          track-by="title"
          label="title"
          @input="updateRecord(c)"
          :showLabels="false"
          :searchable="true"
          :multiple="true"/>
      </div>
      <div>
        <label for="">Действителен до</label>
        <DateSelect :selected-date="c.valid_date" :onSelect="(d) => {
          c.valid_date = d
          updateRecord(c)
        }" :customShortCuts="true"
                    :disabled="true"/>
        <label>
          <input v-model="c.permanent" type="checkbox"> бессрочный
        </label>
      </div>
      <div class="action_btns">
        <button v-if="c.saved" type="button" @click="removeRecord(i)" class="btn btn-outline-danger"><i
          class="icon-fa icon-fa-remove"/></button>
      </div>
    </div>
    <!--    </template>-->
  </div>
</template>

<script>

import DateSelect from "@/views/reports/components/DateSelect.vue";
import Multiselect from 'vue-multiselect'
import moment from 'moment';
import api from "@/api";

export default {
  components: {DateSelect, Multiselect},
  props: ['detail', 'disableStartNewRecord', 'allowToSave'],
  data() {
    return {
      records: []
    }
  },
  computed: {
    $AllProjects() {
      return this.$store.getters["platform/projects"];
    },
  },
  created() {
    // const records = [...(this.detail?.value ?? this.detail?.array_value ?? [])];
    // this.records = records.reduce((acc, r) => {
    //   // console.log(r.valid_date, moment().format('DD.MM.YYYY'), r.valid_date || moment().format('DD.MM.YYYY'))
    //   r.selected_projects = this.$AllProjects.filter((p) => r.selected_projects.includes(p.id));
    //   r.saved = true;
    //   acc.push(r);
    //   return acc;
    // }, [])
    if (!this.disableStartNewRecord) this.addNewRecord();
  },
  methods: {
    async updateRecord(record) {
      if (!this.allowToSave) return;
      const {data} = await api.post('/new/drugs/details/update', {
        action: 'update',
        record: this.detail
      });
      if (data.success) {
        toastr['success'](data.message ?? 'Сохранено', 'Успешно');
      } else {
        toastr['error'](data.message ?? 'Ошибка', 'Внимание');
      }
    },
    getOldestDate() {
      let date = this.getRecords().reduce((acc, r) => {
        if (!r.permanent) {
          let curDate = moment(r.valid_date, 'DD.MM.YYYY');
          if (!acc) {
            acc = curDate;
          } else {
            acc = curDate < acc ? curDate : acc;
          }
        }
        return acc;
      }, null)
      return date ? date.format('YYYY-MM-DD 00:00:00') : null;
    },
    removeRecord(index) {
      // this.detail.to_delete = true;
      delete this.detail.array_value[index];
      this.detail.array_value = this.detail.array_value.filter((r) => r);
      this.updateRecord(this.records[index]);
      // const r = [...this.records];
      // delete r[index];
      // this.records = r.filter((d) => d);
    },
    getRecords() {
      // return this.records.reduce((acc, r) => {
      return this.detail.array_value.reduce((acc, r) => {
        if (!r.comment) return acc;
        acc.push({
          ...r,
          selected_projects: r.selected_projects.filter(p => p).map((p) => p?.id),
          valid_date: r.permanent ? null : r.valid_date
        });
        return acc;
      }, [])
    },
    addNewRecord() {
      // this.records.push({
      if (!this.detail.array_value) this.$set(this.detail, 'array_value', []);
      this.detail.array_value.push({
        comment: null,
        selected_projects: [],
        valid_date: moment().format('DD.MM.YYYY'),
        permanent: false,
      });
    },
    getActiveProjects() {
      return _.orderBy(this.$AllProjects.filter((p) => p.is_active), 'title');
    }
  }
}

</script>

<style scoped>
textarea {
  height: 100%;
}

.action_btns {
  width: 38px;
  display: flex;
  align-items: center;
}

.max_width_30 {
  max-width: 30%;
}
</style>
